import { __awaiter } from 'tslib';
import { Injectable, defineInjectable } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class NgNavigatorShareService {
    constructor() {
        this.webNavigator = null;
        this.webNavigator = window.navigator;
    }
    /**
     * @param {?} __0
     * @return {?}
     */
    share({ title, text, url }) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            if (this.webNavigator !== null && this.webNavigator.share !== undefined) {
                if ((text === undefined || text === null) &&
                    (url === undefined || url === null)) {
                    console.warn(`text and url both can't be empty, at least provide either text or url`);
                }
                else {
                    try {
                        const /** @type {?} */ isShared = yield this.webNavigator.share({
                            title: title,
                            text: text,
                            url: url,
                        });
                        resolve({
                            shared: true
                        });
                    }
                    catch (/** @type {?} */ error) {
                        reject({
                            shared: false,
                            error: error
                        });
                    }
                }
            }
            else {
                reject({
                    shared: false,
                    error: `This service/api is not supported in your Browser`
                });
            }
        }));
    }
}
NgNavigatorShareService.ɵfac = function NgNavigatorShareService_Factory(t) { return new (t || NgNavigatorShareService)(); };
NgNavigatorShareService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NgNavigatorShareService, factory: NgNavigatorShareService.ɵfac, providedIn: 'root' });
/** @nocollapse */
NgNavigatorShareService.ctorParameters = () => [];
/** @nocollapse */ NgNavigatorShareService.ngInjectableDef = defineInjectable({ factory: function NgNavigatorShareService_Factory() { return new NgNavigatorShareService(); }, token: NgNavigatorShareService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgNavigatorShareService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { NgNavigatorShareService };

